import { createActions } from 'redux-actions';
import * as actionTypes from './actionTypes';

export const {
  getLoginUrlRequest,
  getLoginUrlSuccess,
  getLoginUrlFailure,

  getLogoutUrlRequest,
  getLogoutUrlSuccess,
  getLogoutUrlFailure,

  getTokenDataRequest,
  getTokenDataSuccess,
  getTokenDataFailure,

  loadUserRequest,
  loadUserSuccess,
  loadUserFailure,

  loadPermissionsRequest,
  loadPermissionsSuccess,
  loadPermissionsFailure,

  checkTokenRequest,
  checkTokenSuccess,
  checkTokenFailure,

  removePermissions,
} = createActions(
  actionTypes.GET_LOGIN_URL_REQUEST,
  actionTypes.GET_LOGIN_URL_SUCCESS,
  actionTypes.GET_LOGIN_URL_FAILURE,

  actionTypes.GET_LOGOUT_URL_REQUEST,
  actionTypes.GET_LOGOUT_URL_SUCCESS,
  actionTypes.GET_LOGOUT_URL_FAILURE,

  actionTypes.GET_TOKEN_DATA_REQUEST,
  actionTypes.GET_TOKEN_DATA_SUCCESS,
  actionTypes.GET_TOKEN_DATA_FAILURE,

  actionTypes.LOAD_USER_REQUEST,
  actionTypes.LOAD_USER_SUCCESS,
  actionTypes.LOAD_USER_FAILURE,

  actionTypes.LOAD_PERMISSIONS_REQUEST,
  actionTypes.LOAD_PERMISSIONS_SUCCESS,
  actionTypes.LOAD_PERMISSIONS_FAILURE,

  actionTypes.CHECK_TOKEN_REQUEST,
  actionTypes.CHECK_TOKEN_SUCCESS,
  actionTypes.CHECK_TOKEN_FAILURE,

  actionTypes.REMOVE_PERMISSIONS
);
